import { render } from "./addImgIcon.vue?vue&type=template&id=0a68de74"
import script from "./addImgIcon.vue?vue&type=script&lang=js"
export * from "./addImgIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__